import {
  BlockFooter,
  BlockHeader,
  Container,
  ContentWrapper,
} from './styled';

const LayoutDefault = ({ children }) => {
  return (
    <ContentWrapper>
      <Container>
        <BlockHeader />
        {children}
        <BlockFooter />
      </Container>
    </ContentWrapper>
  );
};

export default LayoutDefault;
